import React from 'react'
import {
  Card,
  Row,
  Col,
  Statistic,
  Typography,
  Radio,
  Space,
  Divider,
  Spin,
  Empty
} from 'antd'
import PropTypes from 'prop-types'

const { Title, Text } = Typography

const StoreCounts = ({ title, color, inApp, cancel, refund }) => (
  <Card size="small" title={title} style={{ borderTop: `3px solid ${color}` }}>
    <Row gutter={8}>
      <Col span={8}>
        <Statistic
          title="Покупки"
          value={inApp}
          valueStyle={{ color: '#52c41a' }}
        />
      </Col>
      <Col span={8}>
        <Statistic
          title="Отмены"
          value={cancel}
          valueStyle={{ color: '#faad14' }}
        />
      </Col>
      <Col span={8}>
        <Statistic
          title="Возвраты"
          value={refund}
          valueStyle={{ color: '#ff4d4f' }}
        />
      </Col>
    </Row>
  </Card>
)

StoreCounts.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  inApp: PropTypes.number,
  cancel: PropTypes.number,
  refund: PropTypes.number
}

const TransactionsSection = ({
  stats,
  loading,
  firstTimeBuyersOnly,
  onFirstTimeBuyersToggle
}) => {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ marginBottom: 8 }}>
          Транзакции
        </Title>
        <Radio.Group
          value={firstTimeBuyersOnly}
          onChange={e => onFirstTimeBuyersToggle(e.target.value)}
          buttonStyle="solid"
        >
          <Radio.Button value>Только первые покупки</Radio.Button>
          <Radio.Button value={false}>Все транзакции</Radio.Button>
        </Radio.Group>
      </div>

      <Spin spinning={loading}>
        {stats ? (
          <>
            <Card
              size="small"
              style={{ marginBottom: 16, textAlign: 'center' }}
            >
              <Statistic
                title={
                  firstTimeBuyersOnly
                    ? 'Первых покупок за период'
                    : 'Всего транзакций за период (покупки − возвраты)'
                }
                value={
                  firstTimeBuyersOnly
                    ? stats.firstTimeBuyersCount
                    : stats.totalCounts.totalTransactions
                }
                valueStyle={{ fontSize: 26, fontWeight: 700 }}
              />
            </Card>

            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
              <Col xs={24} md={12}>
                <StoreCounts
                  title="Google Play"
                  color="#3ddc84"
                  inApp={stats.totalCounts.googleInApp}
                  cancel={stats.totalCounts.googleCancel}
                  refund={stats.totalCounts.googleRefund}
                />
              </Col>
              <Col xs={24} md={12}>
                <StoreCounts
                  title="App Store"
                  color="#8c8c8c"
                  inApp={stats.totalCounts.appleInApp}
                  cancel={stats.totalCounts.appleCancel}
                  refund={stats.totalCounts.appleRefund}
                />
              </Col>
            </Row>

            <Card size="small" title="Разбивка по типам подписок">
              <Row gutter={[16, 16]}>
                {stats.subscriptionBreakdown.map(sub => (
                  <Col xs={24} md={8} key={sub.subscriptionType}>
                    <Card
                      size="small"
                      title={sub.subscriptionType}
                      type="inner"
                    >
                      <Space
                        direction="vertical"
                        style={{ width: '100%' }}
                        size={4}
                      >
                        <Text strong style={{ color: '#3ddc84' }}>
                          Google Play
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          Покупки {sub.googleInApp} · Отмены {sub.googleCancel}{' '}
                          · Возвраты {sub.googleRefund}
                        </Text>
                        <Divider style={{ margin: '6px 0' }} />
                        <Text strong style={{ color: '#595959' }}>
                          App Store
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          Покупки {sub.appleInApp} · Отмены {sub.appleCancel} ·
                          Возвраты {sub.appleRefund}
                        </Text>
                        <Divider style={{ margin: '6px 0' }} />
                        <Statistic
                          title="Итого по подписке"
                          value={sub.totalTransactions}
                          valueStyle={{ fontWeight: 700 }}
                        />
                      </Space>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card>
          </>
        ) : (
          !loading && <Empty description="Нет данных за период" />
        )}
      </Spin>
    </div>
  )
}

TransactionsSection.propTypes = {
  stats: PropTypes.object,
  loading: PropTypes.bool,
  firstTimeBuyersOnly: PropTypes.bool.isRequired,
  onFirstTimeBuyersToggle: PropTypes.func.isRequired
}

export default TransactionsSection
